import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { TeamWorkloadRepository } from '../../../infrastructure/repositories/team-workload.repository';

export interface TimeOffTypeOption {
  id: string;
  name: string;
}

@Injectable({ providedIn: 'root' })
export class GetTimeOffTypesUseCase {
  private readonly _repository = inject(TeamWorkloadRepository);

  public execute(): Observable<TimeOffTypeOption[]> {
    return this._repository.getTimeOffTypes();
  }
}
